import { Component, OnInit, Input } from '@angular/core';
import { CustomerModel } from '@admin/customers/shared/models/customer-model';
import { CustomerStatusEnum } from '@admin/customers/shared/models/customer-status.enum';

@Component({
  selector: 'hr-customer-legacy-contacts',
  templateUrl: './customer-legacy-contacts.component.html',
  styleUrls: ['./customer-legacy-contacts.component.less'],
  standalone: false,
})
export class CustomerLegacyContactsComponent implements OnInit {
  @Input()
  public customer: CustomerModel;

  public customerStatusEnum: any = CustomerStatusEnum;

  constructor() {}

  ngOnInit() {}
}
